import BookingPageContainer from "./BookingPageContainer";

// Export the main container component as the default export
export default BookingPageContainer;
